import React from 'react';
import Pre from '../../../../lib/Pre/Pre';
import PriceValue from '../../../../lib/PriceValue/PriceValue';
import { IPricingInfo } from '../../../../types/quote/pricingInfo';

interface IPricingStepProps {
  pricing?: IPricingInfo;
}

const PricingStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<IPricingStepProps>>> = ({ pricing = {} }) => {
  const {
    currencySymbol,
    amount,
    deposit,
    totalPostCredits,
    credits = 0,
    remainder,
    prevDepositUsed,
    prevDepositLeft,
    total,
  } = pricing;

  return (
    <div className="text-xl">
      <div className="text-3xl font-medium">
        <TotalSection {...pricing} />
      </div>

      <div>
        Deposit of{' '}
        <PriceValue currencySymbol={currencySymbol} value={deposit} />
      </div>

      <div hidden={!prevDepositUsed}>
        Less{' '}
        <PriceValue currencySymbol={currencySymbol} value={prevDepositUsed} />{' '}
        deposit already paid
      </div>

      {!!credits && (
        <div>
          Less <PriceValue currencySymbol={currencySymbol} value={credits} /> of
          credits
        </div>
      )}

      <div>
        Book in for additional{' '}
        <PriceValue currencySymbol={currencySymbol} value={amount} />
      </div>

      <div className="mt-8">
        <PriceValue currencySymbol={currencySymbol} value={remainder} /> payable
        on the day
      </div>

      {!!prevDepositLeft && (
        <div className="mt-8 text-lg">
          As you have downgraded the booking, we can put the difference of{' '}
          <PriceValue currencySymbol={currencySymbol} value={prevDepositLeft} />{' '}
          as a credit on your FLAYR account so that you can use it on a deposit
          for a future booking within 6 months.
        </div>
      )}
    </div>
  );
};

function TotalSection({ totalPostCredits, currencySymbol, total }: any) {
  return (
    <>
      {!totalPostCredits && (
        <>
          <PriceValue currencySymbol={currencySymbol} value={total} />
        </>
      )}
      {!!totalPostCredits && (
        <>
          <span className="mr-2 font-normal text-red-500 line-through lg:text-orange-400">
            <PriceValue currencySymbol={currencySymbol} value={total} />
          </span>
          <PriceValue
            currencySymbol={currencySymbol}
            value={totalPostCredits}
          />
        </>
      )}{' '}
      total
    </>
  );
}
export default PricingStep;
